import { render, staticRenderFns } from "./ExcursionPage.vue?vue&type=template&id=c2339bde&scoped=true"
import script from "./ExcursionPage.vue?vue&type=script&lang=ts"
export * from "./ExcursionPage.vue?vue&type=script&lang=ts"
import style0 from "./ExcursionPage.vue?vue&type=style&index=0&id=c2339bde&prod&lang=scss&scoped=true"
import style1 from "./ExcursionPage.vue?vue&type=style&index=1&id=c2339bde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2339bde",
  null
  
)

export default component.exports